<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Regionais</h1>
    <div class="mb-2 mt-3 d-flex" style="gap: 12px">
      <SGPFormSelectComponent 
        :name="'exibirItensDeletados'" :listaDeOptions="opcoesSelect"
        v-model="exibirItensDeletados" :optionLabel="'nome'" :placeholder="'Visualizar Itens Deletados'"
        :error="validationErrors.first('exibirItensDeletados')" data-vv-as="Visualizar Itens Deletados"
        :optionSelecione="'Não'" @change="filtrarDeletados($event)"
      />
      <SGPFormSelectComponent 
        :name="'semModulo'" :listaDeOptions="opcoesSemModulo"
        v-model="semModulo" :optionLabel="'nome'" :placeholder="'Sem módulo'"
        :optionSelecione="'Todos'" @change="aplicarFiltros()" />
    </div>
    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovo" />

    <SGPPaginacaoComponent
      :paginacao="paginacao"
      v-if="listaDeRegionais.data && listaDeRegionais.data.length"
      @sgpAtualizarPaginacao="realizarPaginacao"
      :key="paginacao"
    >
      <SGPTabelaAvancadaComponent
        :colunas="colunas"
        :dados="listaDeRegionais.data"
        :key="JSON.stringify(listaDeRegionais)"
        @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
        @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
        @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
        @sgpTabelaRestaurarSelecionadoEmit="restaurarSelecionado"
        selecionarColunas
        :filtroText="true"
      >
      <template v-slot:item.ctrl_regionais_modulos="{ item }">
        <div v-if="item.ctrl_regionais_modulos && item.ctrl_regionais_modulos.length" style="display: flex; flex-wrap: wrap; gap: 4px; max-width: 260px;">
          <v-chip v-for="mod in item.ctrl_regionais_modulos" :key="mod.id" x-small color="primary" outlined>
            {{ mod.ctrl_modulo.nome }} 
          </v-chip>
        </div>
        <span v-else>—</span>
      </template>
      </SGPTabelaAvancadaComponent>
    </SGPPaginacaoComponent>  
    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="lg"
      titulo="Regional"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioRegionalComponent
        :tipoFormulario="tipoFormulario"
        :regional="regional"
        @fechar="fecharModal"
      />
    </SGPModalComponent> 
    
    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />
    
    <SGPLoadingComponent v-if="loadingRegionais"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioRegionalComponent from '../components/FormularioCtrlRegionaisComponent.vue'


export default {
  components: { FormularioRegionalComponent },
  name: 'CtrlRegionaisPage',

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      regionaisSelecionadas: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      regional: {},
      opcoesSelect: [
        { 'id': true, 'nome': 'Sim' },
        { 'id': false, 'nome': 'Não' }
      ],
      opcoesSemModulo: [
        { 'id': true, 'nome': 'Sim' },
        { 'id': false, 'nome': 'Não' }
      ],
      exibirItensDeletados: ''
    }
  },
  created () {
    this.listarRegionaisComPaginacao();
  },
  computed: {
    ...mapGetters('ctrlRegionais', ['listaDeRegionais','loadingRegionais']),

    paginacao () {
      if (!this.listaDeRegionais.data) return {}
      
      return {
        per_page: this.listaDeRegionais.per_page,
        total: this.listaDeRegionais.total,
        current_page: this.listaDeRegionais.current_page
      }
    },
    colunas () {
      return [
        { key: 'selecionar', label: '', sortable: false },
        { key: 'regional', label: 'Regional', sortable: true },
        { key: 'ctrl_regionais_modulos', label: 'Módulo', sortable: false },
      ]
    }
  },

  methods: {
    ...mapActions('ctrlRegionais', 
    [
      'listarRegionaisComPaginacao',
      'excluirRegionais',
      "restaurarRegional"
    ]),

    realizarPaginacao (paginacao) {
      this.listarRegionaisComPaginacao(this.montarPayload(paginacao));
    },

    gerenciadorDeSelecionados (selecionados) {
      this.regionaisSelecionadas = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.regional = this.regionaisSelecionadas[0];
      this.abrirModal = true;
    },

    restaurarSelecionado(item){
      this.restaurarRegional(item.id);
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    confirmarDelecao () {
      this.excluirRegionais(this.regionaisSelecionadas);
      this.deletarDados = false;
    },

    adicionarNovo () {
      this.regional = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    },

    filtrarDeletados(event) {
      if(typeof event == 'undefined'){
          return false;
      }

      this.listarRegionaisComPaginacao(this.montarPayload());
    },

    aplicarFiltros() {
      this.listarRegionaisComPaginacao(this.montarPayload());
    },

    montarPayload(paginacao = this.paginacao) {
      return {
          ...paginacao,
          trashed: this.exibirItensDeletados,
          sem_modulo: this.semModulo
        }
    }
  }
}
</script>
